<ng-container
   ndtDynamicTile
   [tileConfig]="tileConfig"
   [isFullscreen]="isFullscreen"
   [isEditing]="isEditing"
   [showHeader]="showHeader"
   [isPreview]="isPreview"
   [componentAccessor]="componentAccessor"
>
</ng-container>
